import _ from 'lodash'

// ! this reducer might be replaced by the entitledAppsListOverride in app-portal ui !
// please take a look at that one when this file getting updated, and keep in sync

const EMPTY_LIST = Object.freeze([])

const getEntitledAppList = (entitlements) => {
  if (_.isEmpty(entitlements)) {
    return EMPTY_LIST
  }
  const { 'App Portal': hubInfo, ...apps } = entitlements
  const list = _.values(apps)
    .filter(app => app.enabled !== false)
    .map((app) => ({
      ...app,
      tenants: app.tenants || []
    }))
  if (hubInfo) {
    const { hash, apps: aCount, tenants: tCount } = _.get(apps, 'App Portal', {})
    list._hash = hash ? `0${aCount.toString(36)}A${tCount.toString(36)}X${hash}` : ''
    list._generated = hubInfo.generated || 0
  }
  return list
}

const entitledAppsList = (state = EMPTY_LIST, action) => {
  switch (action.type) {
    case 'SET_ENTITLED_APPS': { // ! this action will be processed by many other reducers !
      const list = getEntitledAppList(action.apps)
      if ((state._hash && list._hash === state._hash) ||
        (state._generated && list._generated <= state._generated)) {
        return state // ignore due to hash is same or generated timestamp is the older or same
      }
      return list
    }
    default:
      return state
  }
}

export default entitledAppsList
